<template>
  <div>
    <div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">
      售后订单/退款订单
    </div>
    <div>
      <el-dialog title="新增售后订单" :visible.sync="editShow" width="800px" @close="close()">
        <el-form label-width="110px" :model="form" :rules="rules" ref="form" size="small">
          <el-form-item label="退款订单号：" prop="orderNo">
            <el-input v-model="form.orderNo" type="text" class="w400" clearable>
              <el-button slot="append" icon="el-icon-search" @click="getOrder(form.orderNo)" size="small"></el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="部分退款：" prop="refundStatus">
            <el-switch v-model="form.refundStatus" :active-value="1" :inactive-value="0"></el-switch>
          </el-form-item>
          <el-form-item label="退款项目：" prop="type">
            <!--<el-input v-model="form.type" type="text" class="w400"></el-input>-->
            <span class="w400">{{ form.type || '--' }}</span>
          </el-form-item>
          <el-form-item label="退款门店：" prop="storeName">
            <!--<el-input v-model="form.storeName" type="text" class="w400"></el-input>-->
            <span class="w400">{{ form.storeName || '--' }}</span>
          </el-form-item>
          <el-form-item label="订单支付时间：" prop="payTime">
            <!--            <el-date-picker type="datetime" v-model="form.payTime" value-format="yyyy-MM-dd HH:mm:ss">-->
            <!--            </el-date-picker>-->
            <span class="w400">{{ form.payTime || '--' }}</span>
          </el-form-item>
          <el-form-item label="订单支付总额：" prop="payTotal">
            <!--<el-input v-model="form.payTotal" type="number" class="w200"></el-input>-->
            <span class="w400">{{ form.payTotal || '0.00' }}</span>
          </el-form-item>
          <!--          <el-form-item label="发型师">-->
          <!--            <el-input v-model="edit.workerName" type="text"></el-input>-->
          <!--          </el-form-item>-->
          <!--          <el-form-item label="门店属性">-->
          <!--						<span v-model="edit.remark">-->
          <!--							{{ edit.remark === 6 ? "加盟店" : "直营店" }}-->
          <!--						</span>-->
          <!--          </el-form-item>-->
          <el-form-item label="退款日期：" prop="refundTime">
            <el-date-picker type="date" v-model="form.refundTime" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="退款金额：" prop="refundTotal">
            <el-input v-model="form.refundTotal" type="number" class="w200" :step="1"></el-input>
          </el-form-item>
          <el-form-item label="退款事由：" prop="refundReason">
            <el-input v-model="form.refundReason" type="textarea" class="w400"></el-input>
          </el-form-item>
          <el-form-item label="是否扣除业绩：" prop="deductCommission">
            <el-radio v-model="form.deductCommission" label="1">是</el-radio>
            <el-radio v-model="form.deductCommission" label="0">否</el-radio>
          </el-form-item>
          <el-form-item label="回收套餐券：" prop="deductCommission" v-if="form.orderType === 11">
            <el-checkbox-group v-model="form.couponCode">
              <el-checkbox :label="item.id" :key="item.id" v-for="item in couponCodeList">{{ item.name }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="卡金积分：" prop="cCardScore" v-if="ccardAvailable === 1">
            <el-select v-model="form.ccardAction" style="width: 85px; margin-right: 5px;">
              <el-option :value="1" label="增加"/>
              <el-option :value="2" label="扣减"/>
            </el-select>
            <el-input v-model="form.ccardScore" type="number" placeholder="请输入卡金" style="width: 200px"></el-input>
            <span style="margin-left: 20px">可退：{{ ccardAvailableAmount }}</span>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
					<el-button @click="editShow=false" size="small">取消</el-button>
					<el-button type="primary" @click="save()" size="small">保存</el-button>
				</span>
      </el-dialog>
    </div>
    <div class="title">
      <div class="left">
        <span style="margin-left: 5px; margin-right: 10px;">退款订单号</span>
        <el-input type="text" style="width: 200px;margin-right: 20px;" size="small" v-model="query.orderNo"
                  clearable></el-input>
        <span style="margin-left: 5px; margin-right: 10px;">退款日期</span>
        <el-date-picker v-model="query.refundTime" @change="" type="daterange" size="small"
                        style="margin-left: 5px;margin-right: 25px; width: 250px;" value-format="yyyy-MM-dd"
                        range-separator="至" clearable>
        </el-date-picker>
        <span style="margin-left: 5px; margin-right: 10px;">门店名称</span>
        <el-input type="text" style="width: 200px;margin-right: 20px;" size="small" v-model="query.storeName"
                  clearable></el-input>
        <el-button type="primary" size="small" @click="getAfterSales()">筛选</el-button>
        <el-button type="primary" size="small" @click="expor()">导出</el-button>
        <el-button type="primary" size="small" @click="add()">新增</el-button>
      </div>
      <div class="right">
      </div>
    </div>
    <div class="tabelContent" style="margin-top: 20px;">
      <el-table :data="afterSales" :header-cell-style="{ background: '#F2F2F4', 'text-align': 'center' }"
                style="width: 100%">
        <el-table-column prop="id" align="center" label="ID" width="50px"></el-table-column>
        <el-table-column prop="payTime" align="center" label="订单支付时间"></el-table-column>
        <el-table-column prop="payTotal" align="center" label="订单支付总额"></el-table-column>
        <el-table-column prop="refundTime" align="center" label="退款日期"></el-table-column>
        <el-table-column prop="type" align="center" label="退款项目"></el-table-column>
        <el-table-column prop="refundTotal" align="center" label="退款金额"></el-table-column>
        <el-table-column prop="refundReason" align="center" label="退款事由"></el-table-column>
        <el-table-column prop="orderNo" align="center" label="退款订单号" width="200px"></el-table-column>
        <el-table-column prop="storeName" align="center" label="退款门店"></el-table-column>
        <el-table-column prop="workerName" align="center" label="发型师"></el-table-column>
        <el-table-column align="center" label="门店属性">
          <template slot-scope="scope">
            {{ scope.row.storeType == 6 ? "加盟店" : "直营店" }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: center;">
        <el-pagination background @current-change="handleCurrentChange" @size-change="handleSizeChange"
                       style="margin-top: 30px;" layout=" total, prev, pager, next, jumper" :current-page="query.page"
                       :total="query.total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {url} from '../../../utils/index.js'
import {export2Excel} from '../../../common/js/util'

export default {
  data() {
    return {
      url: url(),
      editShow: false,
      form: {
        id: "",
        orderNo: "",
        orderType: 1,
        type: "",
        storeName: "",
        payTime: "",
        payTotal: "",
        refundTime: "",
        refundTotal: "",
        refundReason: "",
        deductCommission: '1',
        couponCode: [],
        ccardAction: 1,
        ccardScore: '',
        refundStatus: 0
      },
      rules: {
        orderNo: [
          {required: true, message: '请输入订单编号', trigger: 'blur'},
        ],
        refundTime: [
          {required: true, message: '请选择退款日期', trigger: 'change'}
        ],
        refundTotal: [
          {required: true, message: '请输入退款金额', trigger: 'change'}
        ],
        refundReason: [
          {required: true, message: '请输入退款原由', trigger: 'change'}
        ],
      },
      ccardAvailable: 0,
      ccardAvailableAmount: 0,
      couponCodeList: [],
      query: {
        page: 1,
        size: 10,
        total: 0,
        orderNo: "",
        refundTime: [],
        storeName: "",
        workerName: "",
      },
      afterSales: [],
      columns: [{
        title: '订单支付时间',
        key: 'payTime'
      }, {
        title: '退款日期',
        key: 'refundTime'
      }, {
        title: '退款项目',
        key: 'type'
      }, {
        title: '退款金额',
        key: 'refundTotal'
      }, {
        title: '退款事由',
        key: 'refundReason'
      }, {
        title: '退款订单号',
        key: 'orderNo'
      }, {
        title: '退款门店',
        key: 'storeName'
      }, {
        title: '门店属性',
        key: 'storeType'
      }, {
        title: '发型师',
        key: 'workerName'
      }]
    }
  },
  mounted() {
    // this.getcity()
    this.getAfterSales();
  },
  methods: {
    close() {
      this.$refs['form'].resetFields()
      this.form.orderType = 1
    },
    del(row) {
      this.$confirm('此操作将删除该退款记录, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post("dAftersales/del/" + row.id).then(res => {
          this.getAfterSales()
        });
      })
    },
    expor() {
      this.query.page = null;
      this.getAfterSales();
      var a = this.afterSales
      a.forEach(ele => {
        if (ele.storeType == 6) {
          ele.storeType = "加盟店" //结业门店
        } else {
          ele.storeType = "直营店" //营业门店
        }
      })
      export2Excel(this.columns, a)
    },
    add() {
      this.editShow = true;
    },
    save() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$http.post("dAftersales/save", JSON.stringify(this.form)).then(({data}) => {
            if (data.code === 200) {
              this.editShow = false;
              this.$message.success("保存成功")
              this.close()
              this.getAfterSales();
            } else {
              this.$message.error(data.msg)
            }
          }, resp => {
            this.$message.error("系统异常")
          })
        }
      })

    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getAfterSales();
    },
    handleSizeChange(val) {
      this.query.size = val;
      this.getAfterSales();
    },
    getAfterSales() {
      var a = {
        pageNum: this.query.page,
        pageSize: this.query.size
      }
      if (this.query.orderNo) {
        a.content = this.query.orderNo
      }
      if (this.query.refundTime) {
        a.startTime = this.query.refundTime[0]
        a.endTime = this.query.refundTime[1]
      }
      if (this.query.storeName) {
        a.storeName = this.query.storeName
      }
      if (this.query.workerName) {
        a.workerName = this.query.workerName
      }
      this.$http.get("dAftersales/getAftersales", {
        params: a
      }, {
        emulateJSON: true
      }).then((res) => {
        this.afterSales = res.body.data
        this.query.total = res.body.total;
      });
    },
    getOrder(orderNo) {
      if (!orderNo) {
        this.$message.error("请输入退款订单号")
        return
      }
      this.$http.get(`dAftersales/queryOrder/${orderNo}`).then(({data}) => {
        if (!data.data) {
          this.close()
          this.$message.error("该订单不存在")
          return
        }
        data.data.deductCommission = '1'
        data.data.refundTotal = data.data.payTotal
        data.data.refundTime = new Date()
        data.data.storeName = data.data.storeName || '小程序'
        data.data.couponCode = []
        data.data.ccardAction = 1
        data.data.refundStatus = 0
        this.ccardAvailable = data.data.ccardAvailable
        this.ccardAvailableAmount = data.data.ccardAvailableAmount
        this.couponCodeList = data.data.couponCodeVos;
        this.form = Object.assign({}, data.data)
        // if (this.form.storeName == null || this.form.storeName == '') {
        //   this.form.storeName = '小程序'
        // }
        // if (this.form.workerName == null || this.form.workerName == '') {
        //   this.form.workerName = '无'
        // }
        // this.query.total = data.data.total || 0;
      });
    },
  },
};
</script>

<style lang="less" scoped>
p {
  padding: 0;
  margin: 0;
}

.title {
  width: 100%;

  .left {
    float: left;
  }

  .right {
    float: right;
  }

  &::after {
    content: "";
    width: 1px;
    display: block;
    clear: both;
  }
}

.w200 {
  width: 220px;
}

.w400 {
  width: 400px;
}
</style>
